import Grid from '@mui/material/Grid';

import { BookingFields } from 'reservations/form/components/BookingFields';
import { DinerAuthenticationFields } from 'reservations/form/components/DinerAuthenticationFields';
import { DinerInformationFields } from 'reservations/form/components/DinerInformationFields';

interface Props {
  shouldAuthenticate: boolean;
}

export const BaseDinerFields = ({ shouldAuthenticate }: Props) => (
  <>
    {shouldAuthenticate ? (
      <DinerAuthenticationFields />
    ) : (
      <Grid container item gap="16px" direction="column">
        <DinerInformationFields />
        <BookingFields />
      </Grid>
    )}
  </>
);
